<template>
  <div id="app">
    <transition name="fade" node="out-in">
      <game v-if="isMobile && gameStart" v-on:game-end="gameStart = false"></game>
      <div class="app-wrap" v-else>
        <header-bar v-on:game-start="gameStart = true" :slideLeft="slideLeft" v-if="!isHeaderHidden"></header-bar>
        <section class="transition-wrap">
          <transition v-bind:name="slideLeft ? 'slide-fade-left' : 'slide-fade-right'" mode="out-in">
            <router-view class="content"></router-view>
          </transition>
        </section>
        <footer-bar v-if="!isFooterHidden"></footer-bar>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
    headerBar: () => import('./components/Header'),
    footerBar: () => import('./components/Footer'),
    Game: () => import('./components/game/Game')},
  data () {
    return {
      isMobile: true,
      gameStart: false,
      slideLeft: false
    }
  },
  computed: {
    isHeaderHidden: function () {
      if (
        this.$route.name === 'Redirect' ||
        this.$route.name === 'Mixer' ||
        this.$route.name === 'OnlyFans') {
        return true
      }
      return false
    },
    isFooterHidden: function () {
      if (this.$route.name === 'Mixer') {
        return true
      }
      return false
    }
  },
  methods: {
    mobileCheck () {
      /*eslint-disable */
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
      /*eslint-enable */
    }
  },
  created () {
    this.isMobile = !this.mobileCheck()
  },
  watch: {
    '$route' (to, from) {
      let ordered = ['Home', 'Calendar', 'Community', 'Portfolio', 'Contact']
      if (ordered.indexOf(to.name) >= ordered.indexOf(from.name)) {
        this.slideLeft = false
      } else {
        this.slideLeft = true
      }
    }
  }
}

</script>

<style lang="scss">
@import './variables.scss';
@font-face {
  font-family: 'coolvetica';
  src: url('./assets/fonts/coolvetica.eot') format('embedded-opentype'),
       url('./assets/fonts/coolvetica.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
button {
  font-family: $font-stack;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 1.5px;
}
a{
  text-decoration: none;
}
h1, h2{
  margin-top: 0;
  text-transform: uppercase;
  font-weight: lighter;
}
li, div{
  font-size: 1em;
}
p{
  font-size: 1.25em;
  margin: $standard-spacing2 0;
}

body{
  min-width: $min-page-width;
  background-color: $font-white;
}

canvas {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 101;
  transform: translate(-50%, -50%);
  animation: fadein 2s;
}

@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.app-wrap{
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  opacity: 1.0;
}

.transition-wrap {
  background-color: #595F7F;
  border-top: 3px solid $light-purple;
  flex: 1 0 auto;
  display: flex;
  overflow: hidden;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
     /* IE10+ CSS styles go here */
  .transition-wrap {
    margin-top: -4px;
  }
}

.content{
  display: flex;
  flex-direction: column;
  flex: 1;
}

.white-background-wrap {
  width: 100%;
  background-color: $font-white;
}

.slide-right-enter{
  transform: translateX(15px);
}
.slide-right-enter-active {
  transition: all .7s ease;
}
.slide-right-leave-active {
  transform: translateX(-15px);
  transition: all .7s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-left-enter{
  transform: translateX(-15px);
}
.slide-left-enter-active {
  transition: all .7s ease;
}
.slide-left-leave-active {
  transform: translateX(15px);
  transition: all .7s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-right-enter{
  transform: translateX(15px);
  opacity: 0;
}
.slide-fade-right-enter-active {
  transition: all 300ms ease;
}
.slide-fade-right-leave-active {
  transform: translateX(-15px);
  transition: all 300ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
  opacity: 0;
}
.slide-fade-left-enter{
  transform: translateX(-15px);
  opacity: 0;
}
.slide-fade-left-enter-active {
  transition: all 300ms ease;
}
.slide-fade-left-leave-active {
  transform: translateX(15px);
  transition: all 300ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
  opacity: 0;
}

.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active{
  transition: all .7s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}

.fadeOut-enter-active {
  transition: all .7s ease;
}
.fadeOut-leave-active {
}
.fadeOut-enter, .fadeOut-leave-active {
  opacity: 0;
}

.fade-down-enter-active {
  transition: all .3s ease;
}
.fade-down-leave-active{
  transition: all .7s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-down-enter, .fade-down-leave-active {
  transform: translateY(10px);
  opacity: 0;
}

.section-header{
  display: inline-block;
  border-radius: 25px;
  padding: $standard-spacing-half $standard-spacing2;
  color: $font-white;
  background-color: $light-purple;
}
#app {
  font-family: $font-stack;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  letter-spacing: 1px;
  color: $font-gray;
  font-size: .9em;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.link-btn{
  border: 2px solid $light-purple;
  background-color: rgba(47, 50, 67, .75);
  border-radius: 25px;
  padding: $standard-spacing-half $standard-spacing3/2;
  color: $font-white;
  transition: $standard-transition;
  text-decoration: none;
  &:hover{
    background-color: $light-purple;
    cursor: pointer;
  }
  &:focus{
    background-color: $light-purple;
  }
}
</style>




// WEBPACK FOOTER //
// App.vue?76970f27